import ToolbarService from './ToolbarService';

export default ToolbarService;
